export enum ProgressType {
  NOT_STARTED = "notStarted",
  IN_PROGRESS = "inProgress",
  COMPLETED = "completed",
  CANCELED = "canceled",
  INTERRUPTED = "interrupted",
}

export function getProgressType(step: String): ProgressType {
  let newType: ProgressType | null = null;
  switch (step) {
    case "inProgress":
      newType = ProgressType.IN_PROGRESS;
      break;
    case "completed":
      newType = ProgressType.COMPLETED;
      break;
    case "notStarted":
      newType = ProgressType.NOT_STARTED;
      break;
    case "interrupted":
      newType = ProgressType.INTERRUPTED;
      break;
    case "canceled":
      newType = ProgressType.CANCELED;
      break;
    default:
      console.error("ProgressType is not valid: " + step);
      newType = ProgressType.NOT_STARTED;
      break;
  }
  return newType;
}

export function getProgressTypeString(type: ProgressType): string {
  let translationKey = "";
  switch (type) {
    case ProgressType.IN_PROGRESS:
      translationKey = "patientList.progressInfo.inProgress";
      break;
    case ProgressType.COMPLETED:
      translationKey = "patientList.progressInfo.completed";
      break;
    case ProgressType.NOT_STARTED:
      translationKey = "patientList.progressInfo.notStarted";
      break;
    case ProgressType.INTERRUPTED:
      translationKey = "patientList.progressInfo.interrupted";
      break;
    case ProgressType.CANCELED:
      translationKey = "patientList.progressInfo.canceled";
      break;
    default:
      translationKey = "patientList.progressInfo.notStarted";
      console.error("ProgressType is not valid: " + type);
      break;
  }
  return translationKey;
}
